<header
	[ngClass]="{'obg-m-welcome-bonus-new-flow': moduleData?.redirectTo !== 'deposit'}"
	obg-m-navbar
	(back)="onNavbarCloseClick()"
	[options]="navbarOptions"
	titleText="welcome-bonus.title"
></header>
<div class="obg-m-welcome-bonus-content">
	<obg-m-account-created *ngIf="accountCreated$ | async" hasBonus></obg-m-account-created>
	<ng-container *ngIf="hasOffers">
		<obg-m-bonus-selection
			*ngIf="!alternativeView else altView"
			[items]="items$ | async"
			(itemSelected)="onBonusSelected($event)"
			test-id="welcome-bonus-selection"
			data-test-id="welcome-bonus-selection"
		></obg-m-bonus-selection>
		<ng-template #altView>
			<obg-m-deposit-bonuses
				[items]="items$ | async"
				(depositWithoutBonus)="onBonusSelected(undefined)"
				(getBonus)="onBonusSelected($event)"
			></obg-m-deposit-bonuses>
		</ng-template>
	</ng-container>
</div>
<obg-compact-footer></obg-compact-footer>
